import PropTypes from "prop-types";

// Every settings page shares this header so titles, counts and action buttons line up page to page.
// Buttons in `actions` are normalised to one height here rather than sized by each page.
const ACTIONS_CLASS =
    "flex w-full flex-wrap items-center gap-2 sm:w-auto sm:shrink-0 sm:justify-end " +
    "[&_.ant-btn]:!h-[38px] [&_.ant-btn]:!rounded-full [&_.ant-btn]:!px-5 [&_.ant-btn]:font-medium [&_.ant-btn]:text-[14px]";

const SettingsPageLayout = ({ title, count, description, actions, children, className = "" }) => (
    <div className={`flex h-full min-w-0 flex-col gap-6 ${className}`}>
        <header className="flex flex-col gap-4 border-b border-[#ECECF3] pb-5 sm:flex-row sm:items-start sm:justify-between sm:gap-6">
            <div className="min-w-0">
                <h1 className="flex flex-wrap items-center gap-2 text-[20px] font-semibold leading-tight text-[#2F2F46] lg:text-[22px]">
                    {title}
                    {count != null ? (
                        <span className="rounded-full bg-[#EEEEFE] px-2.5 py-0.5 text-[13px] font-semibold text-[#5D5DF6]">
                            {count}
                        </span>
                    ) : null}
                </h1>
                {description ? (
                    <p className="mt-1.5 max-w-3xl text-[14px] leading-relaxed text-[#787882]">{description}</p>
                ) : null}
            </div>
            {actions ? <div className={ACTIONS_CLASS}>{actions}</div> : null}
        </header>
        <div className="flex min-w-0 flex-1 flex-col">{children}</div>
    </div>
);

SettingsPageLayout.propTypes = {
    title: PropTypes.node.isRequired,
    count: PropTypes.number,
    description: PropTypes.node,
    actions: PropTypes.node,
    children: PropTypes.node,
    className: PropTypes.string,
};

export default SettingsPageLayout;
